<div
  *ngIf="{
    routeCount: routeCount$ | async,
    displayCurrency: displayCurrency$ | async,
    isEuRegion: isEuRegion$ | async,
    isPremium: isPremium$ | async,
    precision: precision$ | async
  } as p"
>
  <div class="d-flex">
    <div
      class="flex-fill flex-grow-0"
      id="route-color"
      style="min-width: 10px"
      [ngStyle]="{
        'background-color': route.isSelected
          ? route.color
          : (route.color | hexToRGBa : 0.4)
      }"
    ></div>
    <div class="flex-fill">
      <div
        class="card-header p-2 d-flex align-items-center bg-gray-0"
        (click)="expandRoutePanel()"
      >
        <div class="flex-grow-1" style="min-width: 1px">
          <!-- Need help to style h5 section -->
          <h5
            class="mb-0 ml-2 mr-1 text-truncate"
            [ngClass]="{
              'open-Width': route.isSelected && route.isOpen,
              'close-Width':
                !route.isSelected || (route.isSelected && !route.isOpen)
            }"
          >
            <span
              style="position: relative"
              *ngIf="!route.isSelected || (route.isSelected && !route.isOpen)"
            >
              <span
                *ngIf="route.savedId !== null && route.profileDeleted === true"
              >
                <i style="color: '#da212c'" class="proifle-icon">error</i>
                <span class="route-name">{{ route.name }}</span>
              </span>

              <span
                *ngIf="
                  route.savedId !== null &&
                  route.profileDeleted === false &&
                  route.profileId === -1
                "
              >
                <i style="color: '#915b12'" class="proifle-icon">warning</i>
                <span class="route-name">{{ route.name }}</span>
              </span>
            </span>
            <span [title]="route.name">
              <span
                *ngIf="
                  !(!route.isSelected || (route.isSelected && !route.isOpen)) ||
                  (!(route.savedId !== null && route.profileDeleted === true) &&
                    !(
                      route.savedId !== null &&
                      route.profileDeleted === false &&
                      route.profileId === -1
                    ))
                "
              >
                {{ route.name }}
              </span>
            </span>
          </h5>
        </div>
        <div
          class="d-flex flex-row flex-shrink-0 align-items-center ml-auto float-right"
        >
          <span
            *ngIf="!route.isSelected || (route.isSelected && !route.isOpen)"
            class="mb-0"
          >
            <span *ngIf="route.totals">
              {{ route.totals.cost | displayCurrency : p.displayCurrency }}&#32;
              <span
                *ngIf="route?.totals?.tolls && (isEuRegion$ | async) !== true"
                >|&#32;{{
                  route.totals.tolls | displayCurrency : p.displayCurrency
                }}</span
              >
              &#32;| {{ route.totals.distance | precision : p.precision }}
              {{ displayDistUnit$ | async }} | {{ route.totals.time }} hrs
            </span>
            <span *ngIf="!route.totals">(No route calculated)</span>
          </span>
          <span
            *ngIf="
              route.stops.length > 1 &&
              route.isOpen &&
              route.isSelected &&
              !route.isSavedCheck
            "
            >(Unsaved changes)</span
          >
          <button
            class="btn btn-icon-only flex-grow-0"
            (click)="
              frameRoute(); $event.preventDefault(); $event.stopPropagation()
            "
            tooltip="Frame Route"
            container="body"
            [adaptivePosition]="false"
            placement="bottom"
            [disabled]="!route.isVisibleOnMap"
          >
            <i class="modus-icons">frame</i>
          </button>
          <div
            class="custom-control custom-switch flex-grow-0 ml-1"
            tooltip="Toggle Route on Map"
            container="body"
            [adaptivePosition]="false"
            placement="bottom"
            (click)="$event.stopPropagation()"
          >
            <input
              type="checkbox"
              (change)="toggleVisibilityOnMap($event)"
              class="custom-control-input"
              id="{{ 'customSwitch' + route.id }}"
              name="example1"
              [checked]="route.isVisibleOnMap"
            />
            <label
              class="custom-control-label"
              for="{{ 'customSwitch' + route.id }}"
            ></label>
          </div>
        </div>
      </div>
      <div class="flex-fill" *ngIf="route.isSelected && route.isOpen">
        <div
          class="alert alert-danger fade show"
          role="alert"
          *ngIf="route.savedId !== null && route.profileDeleted === true"
        >
          <i class="material-icons alert-icon">error</i>
          <span>
            The profile used by this saved route does not exist anymore. Select
            a route profile below.
          </span>
          <button type="button" class="close" data-dismiss="alert">
            <i class="modus-icon material-icons">close</i>
          </button>
        </div>

        <div
          class="alert alert-warning fade show"
          role="alert"
          *ngIf="
            isOldVersion === false &&
            route.savedId !== null &&
            route.profileDeleted === false &&
            route.profileId === -1
          "
        >
          <i class="material-icons alert-icon">warning</i>
          <span class="text-dark">
            This route was not saved with a profile. Select a route profile
            below.
          </span>
          <button type="button" class="close" data-dismiss="alert">
            <i class="modus-icon material-icons">close</i>
          </button>
        </div>

        <!-- <div
          class="alert alert-warning fade show"
          role="alert"
          *ngIf="
            isOldVersion === true &&
            route.savedId !== null &&
            route.profileDeleted === false
          "
        >
          <i class="material-icons alert-icon">warning</i>
          <span class="text-dark">
            This route was saved with an older data verson. Data version 27 or
            older is no longer supported.
          </span>
          <button type="button" class="close" data-dismiss="alert">
            <i class="modus-icon material-icons">close</i>
          </button>
        </div> -->
      </div>
      <div
        class="border-bottom px-3 py-2"
        *ngIf="route.isSelected && route.isOpen"
      >
        <p
          class="card-subtitle-2 mb-0 text-truncate"
          [title]="profileDetails"
          style="max-width: 420px"
        >
          {{ profileDetails }}
        </p>
      </div>

      <!-- Route Options -->
      <!-- <form> -->
      <div
        class="d-flex p-3 align-items-center"
        *ngIf="route.isSelected && route.isOpen"
      >
        <!-- Routing Profile -->
        <div class="mr-auto align-items-center">
          <route-panel-profile-list [route]="route"></route-panel-profile-list>
        </div>

        <div class="form-group mb-0 mr-2">
          <div class="btn-group position-relative" dropdown>
            <button
              dropdownToggle
              class="btn btn-sm btn-outline-secondary dropdown-toggle"
            >
              Stop Options
            </button>
            <ul *dropdownMenu class="dropdown-menu" role="menu">
              <li role="menuitem">
                <button
                  class="dropdown-item small px-2 py-1"
                  (click)="showStopOptions()"
                  [disabled]="route.stops.length < 2 || !hasPremiumSubscription"
                >
                  Stop Time
                </button>
              </li>
              <li role="menuitem" *ngIf="hasPremiumSubscription">
                <button
                  class="dropdown-item small px-2 py-1"
                  (click)="openImportUsersModal()"
                >
                  Import Stops...
                </button>
              </li>
            </ul>
          </div>
        </div>
        <arrive-depart-option [route]="route"></arrive-depart-option>
      </div>
      <app-stop-list
        [routeId]="route.id"
        [routeTotals]="route.totals"
        [displayCurrency]="p.displayCurrency"
        *ngIf="route.isSelected && route.isOpen"
      ></app-stop-list>
      <div
        class="card-footer py-2 px-3 d-flex align-items-center"
        *ngIf="
          route.isSelected &&
          route.isOpen &&
          route.editMode === routeEditModeEnum.AddStop
        "
      >
        <app-reports-button
          [ngClass]="{
            'mr-2': !p.isEuRegion,
            'mr-auto': p.isEuRegion
          }"
          [disabled]="route.stops.length < 2"
          [displayCurrency]="displayCurrency$ | async"
          [routeId]="route.id"
        ></app-reports-button>
        <app-data-version-list
          [disabled]="!p.isPremium || route.stops.length === 1"
          *ngIf="!p.isEuRegion"
          class="mr-auto"
          [route]="route"
        ></app-data-version-list>

        <app-route-optimization [route]="route"></app-route-optimization>

        <button
          class="btn btn-icon-only"
          [disabled]="route.stops.length < 2"
          tooltip="Save Route"
          container="body"
          [adaptivePosition]="false"
          placement="bottom"
          (click)="saveRoute()"
        >
          <i class="modus-icons"
            >cloud_upload
            <svg
              class="img-overlay"
              *ngIf="!route.isSavedCheck"
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
            >
              <g
                transform="translate(2 2)"
                fill="#fbad26"
                stroke="#fff"
                stroke-width="2"
              >
                <circle cx="4" cy="4" r="4" stroke="none" />
                <circle cx="4" cy="4" r="5" fill="none" />
              </g>
            </svg>
          </i>
        </button>

        <button
          class="btn btn-icon-only"
          [ngClass]="{
            'disabled-button': p.routeCount > 7
          }"
          (click)="
            p.routeCount > 7 ? $event.stopPropagation() : duplicateRoute()
          "
          [tooltip]="
            p.routeCount > 7
              ? 'You have the maximum of 8 routes open'
              : 'Duplicate Route'
          "
          [disabled]="route.stops.length < 1"
          container="body"
          [adaptivePosition]="false"
          placement="bottom"
        >
          <i class="modus-icon material-icons">content_copy</i>
        </button>

        <button
          class="btn btn-icon-only"
          (click)="deleteRoute()"
          [disabled]="route.stops.length < 1"
          tooltip="Delete Route"
          container="body"
          [adaptivePosition]="false"
          placement="bottom"
        >
          <i class="modus-icons">trash</i>
        </button>
      </div>
    </div>
  </div>
</div>
<ng-container *ngIf="isLoading$ | async">
  <div class="mt-5 overlay" *ngIf="route.isOpen && route.isSelected">
    <div class="px-3">
      <div class="text-center text-primary">
        <div class="spinner-border"></div>
        <div class="h3 text-primary mt-5">Calculating...</div>
      </div>
    </div>
  </div>
</ng-container>
